import { styled } from '@linaria/react';
import { colors, fonts, layout, primitives, semantic, space } from '../../theme/tokens';
import { EntityImage } from '../../components/EntityImage';

export const SectionBlock = styled.div`
  margin-bottom: ${space['space-1600']};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  flex: 1;
  justify-content: space-between;

  @media (min-width: ${layout.desktopBreakpoint}) {
    flex: initial;
    justify-content: flex-start;
  }
`;

export const SectionTitle = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.xl};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.tight};
`;

export const BannerCard = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  @media (min-width: ${layout.desktopBreakpoint}) {
    aspect-ratio: 21 / 9;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const BannerImage = styled(EntityImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const BannerPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${semantic.bg.surfaceSubtle};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.tertiary};
`;

export const BannerOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to top,
    ${primitives.color.black['color-black-alpha-700']} 0%,
    transparent 60%
  );
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: ${space['space-600']};
`;

export const BannerTitle = styled.span`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.inverse};
  margin-bottom: ${space['space-300']};
`;
